import UserTypes from './types'
const userKey = '_nscorporate_user'

const INITIAL_STATE = {
    user: JSON.parse(
        sessionStorage.getItem(userKey))
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UserTypes.USER_LOGOUT:
            sessionStorage.removeItem(userKey)
            return { ...state, user: null }
        case UserTypes.USER_UPDATE:
            sessionStorage.setItem(userKey, JSON.stringify(action.payload))
            return { ...state, user: action.payload };
        default:
            return state
    }
}